import React, { createContext, useReducer } from 'react';

const initialState = {
  app: {
    isLoaded: false,
  },
};

const STORE_ACTIONS = {
  SET_APP_IS_LOADED: 'SET_APP_IS_LOADED',
};

const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case STORE_ACTIONS.SET_APP_IS_LOADED:
        return {
          ...state,
          app: {
            ...state.app,
            isLoaded: true,
          },
        };
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, STORE_ACTIONS, StateProvider };
